import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import HighestLevelOfQualification from './highest-level-of-qualification';
import HighestLevelOfQualificationDetail from './highest-level-of-qualification-detail';
import HighestLevelOfQualificationUpdate from './highest-level-of-qualification-update';
import HighestLevelOfQualificationDeleteDialog from './highest-level-of-qualification-delete-dialog';

const HighestLevelOfQualificationRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<HighestLevelOfQualification />} />
    <Route path="new" element={<HighestLevelOfQualificationUpdate />} />
    <Route path=":id">
      <Route index element={<HighestLevelOfQualificationDetail />} />
      <Route path="edit" element={<HighestLevelOfQualificationUpdate />} />
      <Route path="delete" element={<HighestLevelOfQualificationDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default HighestLevelOfQualificationRoutes;
